import { render, staticRenderFns } from "./ExtractM9.vue?vue&type=template&id=20b28ce6&"
import script from "./ExtractM9.vue?vue&type=script&lang=js&"
export * from "./ExtractM9.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports